import { restrictedAccess } from '../middleware'

export default {
  path: '/preventive-maintenance',
  component: () => import('@/views/admin/preventive-maintenance/Layout.vue'),
  beforeEnter: restrictedAccess(1),
  children: [
    {
      path: '',
      name: 'preventive-maintenance.list',
      component: () => import('@/views/admin/preventive-maintenance/list/Template.vue'),
    },
    {
      path: 'templates',
      name: 'preventive-maintenance.template',
      component: () => import('@/views/admin/preventive-maintenance/templates/Template.vue'),
    },
    {
      path: 'summary',
      name: 'preventive-maintenance.summary',
      component: () => import('@/views/admin/preventive-maintenance/summary/Template.vue'),
    },
    {
      path: 'summary/:id/edit',
      name: 'preventive-maintenance.summary.edit',
      component: () => import('@/views/admin/preventive-maintenance/summary/EditPage.vue'),
    },
  ],
}
